import React, { ReactNode, SetStateAction } from 'react';

import ResetButton from '../../../../common/filterTable/components/Buttons/ResetButton';
import SearchButton from '../../../../common/filterTable/components/Buttons/SearchButton';
import AgentLoginEmailTextField from '../../../../common/filterTable/components/Filters/AgentLoginEmailTextField';
import AgentRoleMultipleSelection from '../../../../common/filterTable/components/Filters/AgentRoleMultipleSelection';
import AgentStatusSingleSelection from '../../../../common/filterTable/components/Filters/AgentStatusSingleSelection';
import AgentTypeSingleSelection from '../../../../common/filterTable/components/Filters/AgentTypeSingleSelection';
import Filters from '../../../../common/filterTable/components/Filters/Filters';
import FilterActions from '../../../../common/filterTable/layout/FilterActions';
import FilterGrid from '../../../../common/filterTable/layout/FilterGrid';
import DaIdAutoCompleteFilter from '../../../../components/DaIdAutoCompleteFilter';
import { useGenFilterField } from '../../../../utils/ComponentHelper';
import { FilterFields, FilterFieldsKeys } from '../types/FilterFields';

interface FilterSectionProps {
  fields: FilterFields;
  setFields: React.Dispatch<SetStateAction<FilterFields>>;
  onSearch: () => void;
  onReset: () => void;
  DateObj: any;
}

const FilterSection = (props: FilterSectionProps) => {
  const { fields, setFields, onSearch, onReset, DateObj } = props;

  const updateField = (fieldName: string, value: any) => {
    setFields((fields) => {
      return {
        ...fields,
        [fieldName]: value,
      };
    });
  };

  const filterFields: ReactNode[] = useGenFilterField([
    ['creationTime', <DateObj.CreationTime.Picker type="dateTime" />],
    ['lastModifiedTime', <DateObj.LastModifiedTime.Picker type="dateTime" />],

    [
      FilterFieldsKeys.DistributorAgentId,
      <DaIdAutoCompleteFilter
        value={fields[FilterFieldsKeys.DistributorAgentId]}
        onChange={(value) => updateField(FilterFieldsKeys.DistributorAgentId, value)}
        onClear={() => updateField(FilterFieldsKeys.DistributorAgentId, '')}
      />,
    ],
    [
      FilterFieldsKeys.AgentType,
      <AgentTypeSingleSelection
        value={fields[FilterFieldsKeys.AgentType]}
        onChange={(e) => updateField(FilterFieldsKeys.AgentType, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.AgentType, '')}
      />,
    ],
    [
      FilterFieldsKeys.Role,
      <AgentRoleMultipleSelection
        value={fields[FilterFieldsKeys.Role]}
        onChange={(arr: string[]) => updateField(FilterFieldsKeys.Role, arr)}
      />,
    ],
    [
      FilterFieldsKeys.Status,
      <AgentStatusSingleSelection
        value={fields[FilterFieldsKeys.Status]}
        onChange={(e) => updateField(FilterFieldsKeys.Status, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.Status, '')}
      />,
    ],
    [
      FilterFieldsKeys.LoginEmail,
      <AgentLoginEmailTextField
        value={fields[FilterFieldsKeys.LoginEmail]}
        onChange={(e) => updateField(FilterFieldsKeys.LoginEmail, e.target.value)}
      />,
    ],
  ]);

  return (
    <>
      <FilterGrid>
        <Filters filterFields={filterFields} />
      </FilterGrid>
      <FilterActions>
        <SearchButton onSearch={onSearch} />
        <ResetButton onReset={onReset} />
      </FilterActions>
    </>
  );
};

export default FilterSection;
